// Material UI
import { makeStyles } from '@material-ui/core'
import Colors from '../../../../constants/Colors'

export default makeStyles(theme => ({
  listItemIconRoot: {
    fontSize: 24,
    minWidth: 'auto',
  },
  listItemRoot: {
    padding: '16px 24px',
    '&:hover': {
      backgroundColor: Colors.BACKGROUND_ALTERNATIVE_COLOR,
    },
  },
  listItemTextRoot: {
    margin: 0,
    padding: '0px 0px 0px 32px',
  },
  listItemTextPrimary: {
    color: Colors.PRIMARY_FONT_COLOR,
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 'normal',
    letterSpacing: 'normal',
    lineHeight: 'normal',
  },
  selectedListItemRoot: {
    backgroundColor: Colors.BACKGROUND_ALTERNATIVE_COLOR,
  },
  selectedListItemTextPrimary: {
    color: Colors.SECONDARY_COLOR,
    fontFamily: 'Poppins Bold',
  },
}))
